<template>
    <div id="templateRoot">
        
        <Header />

        <Navigation />

        <router-view/>
    
    </div>
</template>




<script>
import Header from '@/views/template/Header'
    import Navigation from '@/views/template/Navigation'

export default {
  name: 'Layout',
    components: {
        Header, Navigation
    }
}
</script>

